export const trackEvent = (eventName, properties = {}) => {
  if (typeof window === 'undefined') return;

  const payload = {
    event: eventName,
    ...properties,
    timestamp: new Date().toISOString(),
  };

  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push(payload);
  }

  window.dispatchEvent(new CustomEvent('mc:analytics', { detail: payload }));
};

export default trackEvent;
